/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @atlaskit/design-system/no-nested-styles */
import "./marker.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
const progressMarkerStyles = null;

/**
 * __Progress marker__
 *
 * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
 */
const ProgressMarker = ({
  testId
}) => /*#__PURE__*/React.createElement("div", {
  "data-testid": testId,
  className: ax(["_2rkou2gc _v5645rui _1bsbu2gc _4t3iu2gc _kqswstnw _bfhkr3ku _1e021ssb _t9ec157a _1lww1oqq _1uuw17dr _1ez2kb7n _1190pbrw _1ia8r3ku"])
});
export default ProgressMarker;